import Skeleton from '@material-ui/lab/Skeleton';
import classNames from 'clsx';
import React from 'react';

import styles from './SelectorSkeleton.scss';

const SelectorSkeleton: React.FC = () => (
  <>
    <Skeleton
      className={styles.skeleton}
      variant="rect"
      height="32px"
      width="80px"
      animation="pulse"
    />
    <Skeleton
      className={classNames(styles.skeleton, styles.middleSkeleton)}
      variant="rect"
      height="20px"
      width="120px"
      animation="pulse"
    />
    <Skeleton
      className={classNames(styles.skeleton, styles.lastSkeleton)}
      variant="rect"
      height="20px"
      width="100%"
      animation="pulse"
    />
  </>
);

export default SelectorSkeleton;
